"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

function _default(observable) {
  return (0, _effects.call)(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var subscription;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _effects.call)(function () {
              return new Promise(function (resolve, reject) {
                observable.subscribe(resolve, reject);
              });
            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            _context.prev = 4;

            if (subscription) {
              subscription.unsubscribe();
            }

            return _context.finish(4);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0,, 4, 7]]);
  }));
}